<template>
  <div>
    <Nuevo
      :dialog="dialog"
      :Item="itemSelected"
      :ItemsAplicacion="ItemsAplicacion"
      v-if="dialog"
      @closeDialog="closeDialog"
    />
    <MensajeTransicion
      color="#FA694A"
      :text="mensaje"
      v-if="verAlerta"
      :top="true"
      :bottom="false"
    />

    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header Principal -->
      <v-toolbar color="secondary" dark flat class="table-header-toolbar px-2 px-sm-3">
        <div class="d-flex align-center header-main-info flex-grow-1 min-width-0">
          <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
            <v-icon color="white">mdi-layers-outline</v-icon>
          </div>
          <div class="header-text-block min-width-0 mr-2 mr-sm-3">
            <div class="header-company-title font-weight-bold text-truncate">
              {{ Titulo || "Lista de Remanente por Aplicación" }}
            </div>
          </div>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="header-count-chip font-weight-bold elevation-1 flex-shrink-0"
          >
            <v-icon left size="16" color="secondary">mdi-counter</v-icon>
            {{ Items ? Items.length : 0 }}
          </v-chip>
        </div>

        <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
          <!-- Botón de Ayuda -->
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1 btn-circle-tooltip"
                icon
                dark
                target="_blank"
                :href="global.helpdesk_url + 'aplicacion'"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="25" color="amber lighten-2">mdi-help-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>¿Necesitas ayuda?</span>
          </v-tooltip>
        </div>
      </v-toolbar>

      <!-- Sección de Búsqueda y Acciones -->
      <div class="pa-2 pa-sm-4 pb-2">
        <div class="d-flex align-center justify-space-between flex-wrap gap-2 mb-3">
          <!-- Búsqueda Rápida -->
          <div class="search-field flex-grow-1 mr-md-3">
            <v-text-field
              v-model="search"
              outlined
              dense
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              placeholder="Buscar por aplicación, valores..."
              class="rounded-lg"
            ></v-text-field>
          </div>

          <!-- Botones de Acción -->
          <div class="action-buttons-group d-flex align-center flex-wrap gap-2 mt-2 mt-md-0">
            <!-- Descargar Excel -->
            <v-btn
              v-if="Excel"
              color="success"
              dark
              height="38"
              class="btn-action-header px-4 font-weight-bold elevation-1 text-none rounded-lg mr-sm-2"
              @click="DescargarExcel()"
            >
              <v-icon left size="18">mdi-file-excel</v-icon>
              Descargar Tabla
            </v-btn>

            <!-- Botón Nueva Aplicación -->
            <v-btn
              v-if="global._autorizacion_usuario(this.Permisos, this.$route.meta.id, ['2'])"
              color="primary"
              dark
              height="38"
              class="btn-action-header px-4 font-weight-bold elevation-1 text-none rounded-lg"
              @click="nuevoItem()"
            >
              <v-icon left size="20">mdi-plus-circle</v-icon>
              Nueva Aplicación
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Indicador de desplazamiento horizontal en celular -->
      <div
        class="d-flex d-sm-none align-center text-caption primary--text mb-2 px-3 pt-1"
      >
        <v-icon x-small color="primary" class="mr-1">
          mdi-gesture-swipe-horizontal
        </v-icon>
        <span>Desliza horizontalmente para ver todos los datos</span>
      </div>

      <!-- Tabla Principal -->
      <div class="table-responsive-wrapper">
        <v-data-table
          dense
          :headers="filteredCabecera"
          :items="Items"
          :items-per-page="10"
          :search="search"
          :mobile-breakpoint="0"
          class="modern-table elevation-0"
          loading-text="Cargando aplicaciones... Por favor, espere"
          no-data-text="No hay aplicaciones disponibles"
          :loading="Loading"
          :footer-props="{
            'items-per-page-text': 'Resultados por página:',
            'items-per-page-options': [5, 10, 25, 50],
            'page-text': '{0}-{1} de {2}'
          }"
        >
          <!-- Columna Acciones -->
          <template v-slot:[`item.acciones`]="{ item }">
            <div class="d-flex align-center justify-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="26"
                    width="26"
                    color="blue lighten-1"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="editarItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar Aplicación</span>
              </v-tooltip>
            </div>
          </template>

          <!-- Columna Aplicación -->
          <template v-slot:[`item.aplicacion_nom`]="{ item }">
            <div class="d-flex align-center">
              <v-avatar size="28" color="blue lighten-5" class="mr-2">
                <v-icon size="16" color="blue darken-2">mdi-layers</v-icon>
              </v-avatar>
              <span class="font-weight-bold text-body-2 text--primary">
                {{ item.aplicacion_nom }}
              </span>
            </div>
          </template>

          <!-- Columna Inicio Reencauche -->
          <template v-slot:[`item.ini_reencauche`]="{ item }">
            <v-chip
              small
              color="blue lighten-5"
              text-color="blue darken-3"
              class="font-weight-bold elevation-1"
            >
              {{ item.ini_reencauche }} mm
            </v-chip>
          </template>

          <!-- Columna Límite Reencauche -->
          <template v-slot:[`item.reencauche`]="{ item }">
            <v-chip
              small
              color="amber lighten-5"
              text-color="amber darken-4"
              class="font-weight-bold elevation-1"
            >
              {{ item.reencauche }} mm
            </v-chip>
          </template>

          <!-- Columna Inicio Próx. Reencauche -->
          <template v-slot:[`item.ini_prox_reencauche`]="{ item }">
            <v-chip
              small
              color="teal lighten-5"
              text-color="teal darken-4"
              class="font-weight-bold elevation-1"
            >
              {{ item.ini_prox_reencauche }} mm
            </v-chip>
          </template>

          <!-- Columna Límite Próx. Reencauche -->
          <template v-slot:[`item.prox_reencauche`]="{ item }">
            <v-chip
              small
              color="deep-orange lighten-5"
              text-color="deep-orange darken-4"
              class="font-weight-bold elevation-1"
            >
              {{ item.prox_reencauche }} mm
            </v-chip>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Nuevo from "./nuevo.vue";
import exportFromJSON from "export-from-json";
import MensajeTransicion from "../Alerta.vue";
import global from "@/global";

export default {
  props: [
    "Titulo",
    "Cabecera",
    "Items",
    "Excel",
    "Crear",
    "Loading",
    "ItemsAplicacion"
  ],
  components: {
    Nuevo,
    MensajeTransicion
  },
  data() {
    return {
      search: "",
      dialog: false,
      itemSelected: {},
      mensaje: "",
      verAlerta: false,
      global: global
    };
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
    canShowAccionColumn() {
      return global._autorizacion_usuario(this.Permisos, this.$route.meta.id, ["3", "4"]);
    },
    filteredCabecera() {
      return this.Cabecera.filter(
        col => !(col.value === "acciones" && !this.canShowAccionColumn)
      );
    }
  },
  methods: {
    ...mapActions("aplicacion", ["cargarAplicacionCMB"]),

    nuevoItem() {
      this.itemSelected = {
        id: null,
        aplicacion: "",
        reencauche: "",
        prox_reencauche: "",
        ini_reencauche: "",
        ini_prox_reencauche: "",
        desg_irregular_1: "",
        desg_irregular_2: "",
        id_remanente: ""
      };
      this.cargarAplicacionCMB();
      this.dialog = true;
    },

    editarItem(item) {
      this.itemSelected = { ...item };
      this.cargarAplicacionCMB(item.aplicacion);
      this.dialog = true;
    },

    DescargarExcel() {
      const data = this.Items;
      const nombreArchivo = "remanente_aplicaciones_" + new Date().toISOString().slice(0, 10);
      const exportType = exportFromJSON.types.xls;
      exportFromJSON({
        data,
        nombreArchivo,
        exportType
      });
    },

    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
/* Toolbar Header Responsive */
.table-header-toolbar {
  min-height: 56px;
}

.table-header-toolbar ::v-deep .v-toolbar__content {
  padding: 8px 14px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-main-info {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
}

.header-icon-box {
  width: 38px;
  height: 38px;
  min-width: 38px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-company-title {
  font-size: 1.1rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-count-chip {
  font-size: 0.85rem !important;
  height: 28px !important;
}

.modern-table ::v-deep table {
  min-width: 900px;
  width: 100%;
}

/* Sticky primera columna (Acciones) */
.modern-table ::v-deep thead th:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 4 !important;
  background-color: #424242 !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.15) !important;
}

.modern-table ::v-deep tbody tr td:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 2 !important;
  background-color: #ffffff !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.06) !important;
}

.modern-table ::v-deep tbody tr:hover td:first-child {
  background-color: #f8fafc !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-size: 0.84rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px;
  white-space: nowrap;
  height: 44px !important;
  border-bottom: none !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th .v-icon {
  color: #ffffff !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th:hover {
  background-color: #333333 !important;
}

.modern-table ::v-deep thead tr.v-data-table__progress th {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep .v-data-table__empty-wrapper td {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 10px 14px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
  transition: background-color 0.15s ease-in-out;
}

.modern-table ::v-deep .v-data-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.82rem;
  padding: 8px 16px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out !important;
}

.action-btn:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.gap-1 {
  gap: 6px;
}

.gap-2 {
  gap: 8px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.88rem !important;
    line-height: 1.2;
  }

  .header-count-chip {
    font-size: 0.75rem !important;
    height: 24px !important;
    padding: 0 6px !important;
  }

  .header-count-chip .v-icon {
    font-size: 14px !important;
    margin-right: 2px !important;
  }

  .search-field {
    width: 100% !important;
    max-width: 100% !important;
    margin-right: 0 !important;
  }

  .action-buttons-group {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 8px !important;
  }

  .btn-action-header {
    width: 100% !important;
    max-width: 100% !important;
    justify-content: center !important;
    margin: 0 !important;
  }

  .modern-table ::v-deep thead th {
    font-size: 0.72rem !important;
    padding: 8px 10px !important;
    height: 38px !important;
  }

  .modern-table ::v-deep td {
    font-size: 0.78rem !important;
    padding: 6px 10px !important;
  }

  .modern-table ::v-deep .v-data-footer {
    flex-wrap: wrap;
    justify-content: center;
    padding: 8px 6px;
    gap: 6px;
  }

  .modern-table ::v-deep .v-data-footer__select {
    margin-right: 6px;
  }

  .modern-table ::v-deep .v-data-footer__pagination {
    margin: 0 4px;
  }
}
</style>
